import { UPLOAD_IMAGE_BY_CARRIER_REQUEST, UPLOAD_IMAGE_BY_CARRIER_SUCCESS, UPLOAD_IMAGE_BY_CARRIER_FAILURE, } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const uploadImageByCarrierReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_IMAGE_BY_CARRIER_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_IMAGE_BY_CARRIER_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_IMAGE_BY_CARRIER_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        default:
            return state;
    }
};
export default uploadImageByCarrierReducer;
